<template>
  <v-row no-gutters>
    <customer-list v-if="userData.role === 'PLSYR' && $vuetify.breakpoint.xsOnly" />
    <v-col v-if="appStore.isCustomer" class="delayEl">
      <CustomerAlert />
    </v-col>
    <v-col v-else>
      <div id="document-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <v-card
          tile
          :disabled="store.cardDisabled"
          :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'"
        >
          <PageHeader />
          <v-data-table
            :headers="store.tableColumns"
            :items="store.tableItems"
            :loading="store.tableLoading"
            :height="pageStore.tableHeight"
            loader-height="2"
            :items-per-page="-1"
            :mobile-breakpoint="100"
            fixed-header
            hide-default-footer
            :expanded.sync="store.tableExpandedSync"
            item-key="DOCNUM"
            show-expand
            single-expand
          >
            <!-- Arama Alanı -->
            <template v-slot:body.prepend>
              <tr class="data-table-body-search">
                <!-- Boş -->
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>

                <td class="pa-0" v-if="store.tableEmptySearch === 6">
                  <v-select
                    v-model="store.tableSearch_1"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Hepsi', value: '' },
                      { text: 'Açık', value: 'Açık' },
                      { text: 'Kısmi Açık', value: 'Kısmi Açık' },
                      { text: 'Kapalı', value: 'Kapalı' },
                      { text: 'Açık + Kısmi Açık', value: 'Açık + Kısmi Açık' },
                    ]"
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>

                <td class="pa-0">
                  <v-text-field
                    v-model="store.tableSearch_2"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Boş -->
                <td
                  class="pa-0"
                  v-for="item in store.tableEmptySearch"
                  :key="`emptySearch-${item}`"
                >
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
              </tr>
            </template>

            <!-- Expand Table -->
            <template v-slot:expanded-item="{ headers }">
              <td :colspan="headers.length">
                <v-data-table
                  :headers="store.tableExpandColumns"
                  :items="store.tableExpandItems"
                  :loading="store.tableExpandLoading"
                  loader-height="2"
                  :items-per-page="-1"
                  :mobile-breakpoint="100"
                  hide-default-footer
                >
                  <!-- Arama Alanı -->
                  <template v-slot:body.prepend>
                    <tr class="data-table-body-search">
                      <!-- Malzeme Kod -->
                      <td class="pa-0">
                        <div class="d-flex">
                          <v-text-field
                            v-model="store.tableExpandSearch_1"
                            :prepend-inner-icon="icons.mdiMagnify"
                            persistent-placeholder
                            clearable
                            placeholder="Ara"
                            filled
                            class="rounded-0 elevation-0"
                            hide-details
                          />
                        </div>
                      </td>

                      <!-- Ürün -->
                      <td class="pa-0">
                        <div class="d-flex">
                          <v-text-field
                            v-model="store.tableExpandSearch_2"
                            :prepend-inner-icon="icons.mdiMagnify"
                            persistent-placeholder
                            clearable
                            placeholder="Ara"
                            filled
                            class="rounded-0 elevation-0"
                            hide-details
                          />
                        </div>
                      </td>

                      <!-- Boş -->
                      <td
                        class="pa-0"
                        v-for="item in store.tableExpandEmptySearch"
                        :key="`emptySearch-${item}`"
                      >
                        <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </td>
            </template>

            <!-- Statü -->
            <template #[`item.STATX`]="{ item }">
              <v-chip
                :color="item.STATX === 'Açık' ? 'error' : 'success'"
                class="d-flex justify-center"
                label
              >
                <div
                  class="text-truncate data-table-item-type-one"
                  style="min-width: 90px !important"
                >
                  {{ item.STATX }}
                </div>
              </v-chip>
            </template>

            <!-- Belge No -->
            <template #[`item.PRINTEDNO`]="{ item }">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="text-truncate data-table-item-type-one"
                  style="min-width: 90px !important"
                >
                  {{ item.PRINTEDNO || "BELİRSİZ" }}
                </div>
              </v-chip>
            </template>

            <!-- Belge No Sipariş-->
            <template #[`item.DOCNUM`]="{ item }">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="text-truncate data-table-item-type-one"
                  style="min-width: 90px !important"
                >
                  {{ item.DOCNUM || "BELİRSİZ" }}
                </div>
              </v-chip>
            </template>

            <!-- Cari Unvan -->
            <template #[`item.NAME1`]="{ item }">
              <div class="d-flex align-center">
                <div>
                  <div class="text-subtitle-2 white--text text-capitalize text-no-wrap">
                    {{ item.NAME1 }}
                  </div>
                  <div class="text-caption text--disabled">
                    <span v-if="item.DOCTYPE === 'Y1'">{{ item.HEADLTEXT }}</span>
                    <span v-else>{{ item.SELDOCTTXT }}</span>
                  </div>
                </div>
              </div>
            </template>

            <!-- Vade Tarih -->
            <template #[`item.VALIDFROM`]="{ item }">
              <v-tooltip color="chip" bottom v-if="item.VALIDFROM">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                    <div
                      class="text-truncate d-flex align-center data-table-item-type-one"
                      style="width: 100px !important"
                    >
                      <v-icon small class="mr-2">
                        {{ icons.mdiCalendar }}
                      </v-icon>
                      <div class="mr-1">
                        {{ item.VALIDFROM }}
                      </div>
                    </div>
                  </v-chip>
                </template>
                <div>
                  {{ item.VALIDFROM }}
                </div>
              </v-tooltip>
            </template>

            <!-- Tutar -->
            <template #[`item.GROSS`]="{ item }">
              <div v-if="item.GROSS" class="text-caption font-weight-medium">
                {{ item.GROSS | currency({ symbol: "" }) }}
              </div>
            </template>

            <!-- KDV -->
            <template #[`item.VATAMNT`]="{ item }">
              <div v-if="item.VATAMNT" class="text-caption font-weight-medium">
                {{ item.VATAMNT | currency({ symbol: "" }) }}
              </div>
            </template>

            <!-- Genel Toplam -->
            <template #[`item.GRANDTOTAL`]="{ item }">
              <div v-if="item.GRANDTOTAL" class="text-caption white--text font-weight-medium">
                {{ item.GRANDTOTAL | currency({ symbol: "" }) }}
              </div>
            </template>

            <!-- Actions -->
            <template #[`item.actions`]="{ item }">
              <document-download :item="item" />
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, onUnmounted, watch } from "vue-demi";

// Pinia
import { useDocumentStore } from "./_store";
import { useAppStore } from "@/stores/app";
import { usePageStore } from "@/stores/pageHeader";
import store from "@/store";
// Units
import { useRouter } from "@core/utils";

// Components
import PageHeader from "@/components/PageHeader/Index.vue";
import CustomerAlert from "@/components/CustomerAlert.vue";

// Icons
import { mdiFileDocument, mdiMagnify, mdiCalendar } from "@mdi/js";
import DocumentDownload from "./DocumentDownload.vue";
import CustomerList from "@/components/CustomerList.vue";
export default {
  components: {
    PageHeader,
    CustomerAlert,
    DocumentDownload,
    CustomerList
  },
  setup() {
    // Initial
    const store = useDocumentStore();
    const appStore = useAppStore();
    const pageStore = usePageStore();
    const { route } = useRouter();
    const userData = JSON.parse(localStorage.getItem("userData"));
    const pageSettings = () => {
      pageStore.pageTitle = store.documentType.title;
      pageStore.pageIcon = mdiFileDocument;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRange = true;
      pageStore.hasActions = false;

      pageStore.downloadHeader = {
        "Belge No": "DOCNUM",
        CNS: "PRINTEDNO",
        "Belge Tipi": "DOCTYPE",
        Statü: "STATX",
        "Cari Unvan": "NAME1",
        Tarih: "VALIDFROM",
        "Tutar (TL)": "GROSS",
        "KDV (TL)": "VATAMNT",
        "Toplam (TL)": "GRANDTOTAL",
      };
    };

    // Expand sistemi izleniyor
    watch(
      () => store.tableExpandedSync,
      (item) => {
        store.tableExpandSearch_1 = store.tableExpandSearch_2 = "";
        if (item.length > 0) {
          store.watchTableExpand(item[0].DOCNUM, item[0].DOCTYPE);
        }
      }
    );

    // İç sayfa değişimi izleniyor
    watch(
      () => route.value.params.folder,
      () => {
        store.documentFind(route.value.params.folder);
        pageStore.pageTitle = store.documentType.title;
        if (!appStore.isCustomer) {
          store.tableSearch_1 = store.tableSearch_2 = "";
          store.tableColumnsFn(route.value.params.folder);
          store.tableFetch(pageStore.dateRange);
        }
      }
    );

    // Müşteri seçimi gerekiyorsa değişiklikler izleniyor
    watch(
      () => appStore.selectedCustomer,
      () => {
        if (!appStore.isCustomer) {
          store.tableColumnsFn(route.value.params.folder);
          store.tableFetch(pageStore.dateRange);
        }
      }
    );

    // Tarih aralığı için değişiklikler izleniyor
    watch(
      () => pageStore.dateRange,
      (newVal) => {
        if (!appStore.isCustomer) {
          store.tableColumnsFn(route.value.params.folder);
          store.tableFetch(newVal);
        }
      }
    );

    onMounted(() => {
      store.documentFind(route.value.params.folder);
      pageSettings();
      if (appStore.isCustomer) return;
      store.tableColumnsFn(route.value.params.folder);
      store.tableFetch(pageStore.dateRange);
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    return {
      // Pinia
      store,
      appStore,
      pageStore,
      userData,
      // icons
      icons: {
        mdiFileDocument,
        mdiMagnify,
        mdiCalendar,
      },
    };
  },
};
</script>
<style>
.v-data-table__expanded__content > td {
  background: #28243d !important;
  padding: 0 0 70px 0 !important;
}
.v-application.theme--dark .v-data-table .v-data-table__expanded__content th {
  background-color: #0d6efd !important;
  color: white !important;
}
.v-application.theme--dark .v-data-table .v-data-table__expanded__content tr {
  background-color: #3b355a !important;
}
.v-application.theme--dark .v-data-table .v-data-table__expanded__content tr:hover {
  background-color: #2d2844 !important;
}
</style>
